/**经销商&门店路由 */
export default {
    name: 'agent',
    path: 'agent',
    meta: { title: '经销商&门店' },
    component: () => import('@/pages/index.vue'),
    children: [
        {
            name: 'agent-list',
            path: 'list',
            meta: { title: '经销商列表' },
            component: () => import('@/pages/agent/list.vue')
        },
        {
            name: 'agent-grade',
            path: 'grade',
            meta: { title: '经销商等级' },
            component: () => import('@/pages/agent/grade.vue')
        },
        {
            name: 'agent-storelist',
            path: 'storelist',
            meta: { title: '门店列表' },
            component: () => import('@/pages/agent/storelist.vue')
        },
        {
            name: 'agent-type',
            path: 'type',
            meta: { title: '门店类型' },
            component: () => import('@/pages/agent/type.vue')
        },
        {
            name: 'agent-set',
            path: 'set',
            meta: { title: '设置' },
            component: () => import('@/pages/agent/set.vue')
        }
    ]

}